import React, { useEffect } from "react";

import { Link } from "react-router-dom";
import { MsgSucess } from "../components/Shared";

import "./css/HomePage.css";

export const Home = ({ message, setMessage }) => {
  useEffect(() => {
    setTimeout(() => {
      setMessage(null);
    }, 1000000);
  }, [message, setMessage]);
  let novaData = new Date();
  console.log(novaData);
  return (
    <div className="container">
      <div className="wrap container px-5 pt-3">
        <div>
          {message && (
            <MsgSucess>
              <div
                className="msg-sucess-new"
                dangerouslySetInnerHTML={{ __html: message }}
              ></div>
            </MsgSucess>
          )}
        </div>
        <section className="container">
          <p className="p">Bem-vindo ao Canal de Ouvidoria do 1RIGO</p>
          <div className="mb-3">
            <p>
              A Ouvidoria é o canal de comunicação entre a Serventia e seus
              usuários e colaboradores para o tratamento de elogio, reclamações
              e sugestões.
            </p>
            <p>
              A atuação da Ouvidoria é pautada na ética, imparcialidade,
              transparência, sigilo e defesa dos interesses legítimos do
              usuário.
            </p>
            <p>
              Proporcionar esse canal de relacionamento é reconhecer a
              importância do usuário e colaboradores na melhoria dos processos e
              serviços do Registro de Imóveis da 1ª Circunscrição de Goiânia.
            </p>
          </div>
        </section>
        <section className="d-flex container wrap-site row mt-3">
          <Link to="/tipos" className="col-sm-12 col-md-6 col-lg-6">
            <div className="card-body">
              <p>
                <i className="bi bi-chat-right-quote"></i>
              </p>
              <p className="p">Envie uma manifestação</p>
              <span className="span">
                Você pode utilizar nosso formulário eletrônico.
              </span>
            </div>
          </Link>
          <Link to="/acompanhamento/" className="col-sm-12 col-md-6 col-lg-6">
            <div className="card-body">
              <p>
                <i className="bi bi-folder-plus"></i>
              </p>
              <p className="p">Acompanhe sua manifestação</p>
              <span className="span">
                Veja as atualizações através do número de protocolo.
              </span>
            </div>
          </Link>
          {/*
          <Link to="/" className="col-sm-12 col-md-4 col-lg-4 disabled">
            <div className="card-body disabled">
              <p>
                <i className="bi bi-patch-question"></i>
              </p>
              <p className="p">Como funciona o canal?</p>
              <span className="span">
                Conheça como funciona o canal de ouvidoria.
              </span>
            </div>
          </Link>
              */}
        </section>
      </div>
    </div>
  );
};
